/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkshopsRouteImport } from './routes/workshops'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as TicketsRouteImport } from './routes/tickets'
import { Route as StandupRouteImport } from './routes/standup'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectsUsersTrackingRouteImport } from './routes/projects.users-tracking'
import { Route as ProjectsDashboardRouteImport } from './routes/projects.dashboard'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects.$projectId'
import { Route as ProjectsAuditProjectIdRouteImport } from './routes/projects.audit.$projectId'

const WorkshopsRoute = WorkshopsRouteImport.update({
  id: '/workshops',
  path: '/workshops',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsRoute = TicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => rootRouteImport,
} as any)
const StandupRoute = StandupRouteImport.update({
  id: '/standup',
  path: '/standup',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsUsersTrackingRoute = ProjectsUsersTrackingRouteImport.update({
  id: '/users-tracking',
  path: '/users-tracking',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsDashboardRoute = ProjectsDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/$projectId',
  path: '/$projectId',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsAuditProjectIdRoute = ProjectsAuditProjectIdRouteImport.update({
  id: '/audit/$projectId',
  path: '/audit/$projectId',
  getParentRoute: () => ProjectsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/standup': typeof StandupRoute
  '/tickets': typeof TicketsRoute
  '/verify': typeof VerifyRoute
  '/workshops': typeof WorkshopsRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/dashboard': typeof ProjectsDashboardRoute
  '/projects/users-tracking': typeof ProjectsUsersTrackingRoute
  '/projects/audit/$projectId': typeof ProjectsAuditProjectIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/standup': typeof StandupRoute
  '/tickets': typeof TicketsRoute
  '/verify': typeof VerifyRoute
  '/workshops': typeof WorkshopsRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/dashboard': typeof ProjectsDashboardRoute
  '/projects/users-tracking': typeof ProjectsUsersTrackingRoute
  '/projects/audit/$projectId': typeof ProjectsAuditProjectIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/standup': typeof StandupRoute
  '/tickets': typeof TicketsRoute
  '/verify': typeof VerifyRoute
  '/workshops': typeof WorkshopsRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/dashboard': typeof ProjectsDashboardRoute
  '/projects/users-tracking': typeof ProjectsUsersTrackingRoute
  '/projects/audit/$projectId': typeof ProjectsAuditProjectIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/projects'
    | '/sign-in'
    | '/sign-up'
    | '/sso-callback'
    | '/standup'
    | '/tickets'
    | '/verify'
    | '/workshops'
    | '/projects/$projectId'
    | '/projects/dashboard'
    | '/projects/users-tracking'
    | '/projects/audit/$projectId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/projects'
    | '/sign-in'
    | '/sign-up'
    | '/sso-callback'
    | '/standup'
    | '/tickets'
    | '/verify'
    | '/workshops'
    | '/projects/$projectId'
    | '/projects/dashboard'
    | '/projects/users-tracking'
    | '/projects/audit/$projectId'
  id:
    | '__root__'
    | '/'
    | '/projects'
    | '/sign-in'
    | '/sign-up'
    | '/sso-callback'
    | '/standup'
    | '/tickets'
    | '/verify'
    | '/workshops'
    | '/projects/$projectId'
    | '/projects/dashboard'
    | '/projects/users-tracking'
    | '/projects/audit/$projectId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProjectsRoute: typeof ProjectsRouteWithChildren
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  SsoCallbackRoute: typeof SsoCallbackRoute
  StandupRoute: typeof StandupRoute
  TicketsRoute: typeof TicketsRoute
  VerifyRoute: typeof VerifyRoute
  WorkshopsRoute: typeof WorkshopsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workshops': {
      id: '/workshops'
      path: '/workshops'
      fullPath: '/workshops'
      preLoaderRoute: typeof WorkshopsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets': {
      id: '/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof TicketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/standup': {
      id: '/standup'
      path: '/standup'
      fullPath: '/standup'
      preLoaderRoute: typeof StandupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/users-tracking': {
      id: '/projects/users-tracking'
      path: '/users-tracking'
      fullPath: '/projects/users-tracking'
      preLoaderRoute: typeof ProjectsUsersTrackingRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/dashboard': {
      id: '/projects/dashboard'
      path: '/dashboard'
      fullPath: '/projects/dashboard'
      preLoaderRoute: typeof ProjectsDashboardRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/audit/$projectId': {
      id: '/projects/audit/$projectId'
      path: '/audit/$projectId'
      fullPath: '/projects/audit/$projectId'
      preLoaderRoute: typeof ProjectsAuditProjectIdRouteImport
      parentRoute: typeof ProjectsRoute
    }
  }
}

interface ProjectsRouteChildren {
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ProjectsDashboardRoute: typeof ProjectsDashboardRoute
  ProjectsUsersTrackingRoute: typeof ProjectsUsersTrackingRoute
  ProjectsAuditProjectIdRoute: typeof ProjectsAuditProjectIdRoute
}

const ProjectsRouteChildren: ProjectsRouteChildren = {
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ProjectsDashboardRoute: ProjectsDashboardRoute,
  ProjectsUsersTrackingRoute: ProjectsUsersTrackingRoute,
  ProjectsAuditProjectIdRoute: ProjectsAuditProjectIdRoute,
}

const ProjectsRouteWithChildren = ProjectsRoute._addFileChildren(
  ProjectsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProjectsRoute: ProjectsRouteWithChildren,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  SsoCallbackRoute: SsoCallbackRoute,
  StandupRoute: StandupRoute,
  TicketsRoute: TicketsRoute,
  VerifyRoute: VerifyRoute,
  WorkshopsRoute: WorkshopsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
